import { AsyncPipe, NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
  Self,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CheckoutCardPaymentProvidersComponent } from '@checkout/ui-components';
import { QuoteOfferPricePipe } from '@domgen/dgx-fe-basket';
import { PaymentType } from '@domgen/dgx-fe-common';
import { TestHookDirective } from '@domgen/dgx-fe-components/general';
import {
  FormFieldComponent,
  FormFieldDirective,
  FormRowComponent,
  FormSubmitButtonComponent,
} from '@domgen/dgx-fe-forms/layout';
import { RadioCardComponent } from '@domgen/dgx-fe-forms/radio';
import { FormSubmitDirective } from '@domgen/dgx-fe-forms/shared';
import { GAFormFieldDirective } from '@domgen/dgx-fe-ga';
import {
  CurrencyFormatPipe,
  provideTranslationDictionaryMapping,
  TranslatePipe,
} from '@domgen/dgx-fe-i18n';
import { translation } from '../../i18n/translation.constant';
import { PaymentMethodFormValue } from '../../models/payment-method-form-value.interface';
import { PaymentMethodFormBuilderService } from '../../services/payment-method-form-builder/payment-method-form-builder.service';
import { PaymentMethodFormComponentService } from '../../services/payment-method-form-component/payment-method-form-component.service';
import { PaymentMethodTestHooks } from '../../test/payment-method-test-hooks.enum';

@Component({
  selector: 'checkout-payment-method-form',
  standalone: true,
  imports: [
    AsyncPipe,
    CheckoutCardPaymentProvidersComponent,
    CurrencyFormatPipe,
    FormFieldComponent,
    FormFieldDirective,
    FormRowComponent,
    FormSubmitButtonComponent,
    FormSubmitDirective,
    GAFormFieldDirective,
    NgIf,
    QuoteOfferPricePipe,
    RadioCardComponent,
    ReactiveFormsModule,
    TestHookDirective,
    TranslatePipe,
  ],
  templateUrl: './payment-method-form.component.html',
  styleUrls: ['./payment-method-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    PaymentMethodFormBuilderService,
    PaymentMethodFormComponentService,
    provideTranslationDictionaryMapping(translation),
  ],
})
export class PaymentMethodFormComponent {
  testHooks = PaymentMethodTestHooks;

  @Output() submitted = new EventEmitter<PaymentType>();

  constructor(@Self() readonly cs: PaymentMethodFormComponentService) {}

  onSubmit(formValue: PaymentMethodFormValue): void {
    this.submitted.emit(formValue.paymentType);
  }
}
